'use client';

import { useParams } from 'next/navigation';
import { useTripBookingStore } from '~/stores/tpv2/tripBookingStore';

export const REWRITTEN_TRIP_ID_HISTORY_KEY = 'bywayRewrittenTripId';

export const readRewrittenTripId = (): string => {
  const stamped: unknown = globalThis.history.state?.[REWRITTEN_TRIP_ID_HISTORY_KEY];
  return typeof stamped === 'string' && globalThis.location.pathname.includes(stamped) ? stamped : '';
};

export const useTripId = () => {
  const params = useParams();
  const rawParamTripId = params?.tripId ?? params?.journeyId;
  const paramTripId = typeof rawParamTripId === 'string' ? rawParamTripId : '';
  const storeTripId = useTripBookingStore((s) => s.activeTripId);
  // Store wins over the URL param: a trip edit rebuilds the trip into a new id and
  // updates the store synchronously, but swaps the URL via history.replaceState
  // (no navigation) so `useParams` keeps returning the pre-edit id. The store is
  // kept in sync with the param on every load/navigation by TripBookingStoreInitializer.
  return storeTripId || paramTripId;
};
